import { render, staticRenderFns } from "./ScorecardAccordion.vue?vue&type=template&id=65f19f9e"
import script from "./ScorecardAccordion.vue?vue&type=script&lang=js"
export * from "./ScorecardAccordion.vue?vue&type=script&lang=js"
import style0 from "./ScorecardAccordion.vue?vue&type=style&index=0&id=65f19f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports